import React, { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import { SkeletonPage } from "@/components/SkeletonLoaders";

const ServiceListingPage = lazy(() => import("./pages/ServiceListingPage"));
const ServiceSlotBook = lazy(() => import("./pages/ServiceSlotBook"));
const ServiceSummaryPage = lazy(() => import("./pages/ServiceSummaryPage"));
const ServiceThanksPage = lazy(() => import("./pages/ServiceThanksPage"));


const homeServicesRoutes = [
    // Cleaning Routes
    {
        path: "cleaning/:category_id",
        element: (
            <Suspense fallback={<SkeletonPage />}>
                <ServiceListingPage flow="cleaning" />
            </Suspense>
        ),
    },
    {
        path: "cleaning/:category_id/slot-book",
        element: (
            <Suspense fallback={<SkeletonPage />}>
                <ServiceSlotBook />
            </Suspense>
        ),
    },
    {
        path: "cleaning/:category_id/summary",
        element: (
            <Suspense fallback={<SkeletonPage />}>
                <ServiceSummaryPage />
            </Suspense>
        ),
    },
    {
        path: "cleaning/:category_id/thanks",
        element: (
            <Suspense fallback={<SkeletonPage />}>
                <ServiceThanksPage />
            </Suspense>
        ),
    },

    // Electrician Routes
    {
        path: "electrician/:category_id",
        element: (
            <Suspense fallback={<SkeletonPage />}>
                <ServiceListingPage flow="electrician" />
            </Suspense>
        ),
    },
    {
        path: "electrician/:category_id/slot-book",
        element: (
            <Suspense fallback={<SkeletonPage />}>
                <ServiceSlotBook />
            </Suspense>
        ),
    },
    {
        path: "electrician/:category_id/summary",
        element: (
            <Suspense fallback={<SkeletonPage />}>
                <ServiceSummaryPage />
            </Suspense>
        ),
    },
    {
        path: "electrician/:category_id/thanks",
        element: (
            <Suspense fallback={<SkeletonPage />}>
                <ServiceThanksPage />
            </Suspense>
        ),
    },

    // Plumber Routes
    {
        path: "plumber/:category_id",
        element: (
            <Suspense fallback={<SkeletonPage />}>
                <ServiceListingPage flow="plumber" />
            </Suspense>
        ),
    },
    {
        path: "plumber/:category_id/slot-book",
        element: (
            <Suspense fallback={<SkeletonPage />}>
                <ServiceSlotBook />
            </Suspense>
        ),
    },
    {
        path: "plumber/:category_id/summary",
        element: (
            <Suspense fallback={<SkeletonPage />}>
                <ServiceSummaryPage />
            </Suspense>
        ),
    },
    {
        path: "plumber/:category_id/thanks",
        element: (
            <Suspense fallback={<SkeletonPage />}>
                <ServiceThanksPage />
            </Suspense>
        ),
    },
];

export default homeServicesRoutes;
